import { FormControl, MenuItem, FormHelperText } from '@mui/material';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { getPeopleTypes } from '../../fetch';
import { IDropdownResponse } from '../../models';
import { SMBSelect } from '../input';

interface IPersonTypeDropdownProps {
  value: string | number;
  handleChange: (val: string) => void;
  isDisabled?: boolean;
  setOptions?: (val: IDropdownResponse[]) => void;
  isRequired?: boolean;
  message?: string;
  hasError?: boolean;
}

export const PersonTypeDropdown: FC<IPersonTypeDropdownProps> = ({
  isDisabled,
  isRequired,
  value,
  handleChange,
  setOptions,
  message,
  hasError
}) => {
  const { isLoading, data: personTypes } = useQuery<IDropdownResponse[], Error>(
    ['getPeopleTypes'],
    () => getPeopleTypes(),
    {
      notifyOnChangeProps: 'tracked',
      onSuccess: d => setOptions?.(d)
    }
  );
  return (
    <FormControl fullWidth variant="outlined" size="small" required={isRequired} error={hasError}>
      <SMBSelect
        disabled={isDisabled || isLoading}
        name={`personType`}
        variant="outlined"
        label={isLoading ? 'Loading...' : 'Person Type'}
        id={`personType`}
        value={value}
        size="small"
        handleClear={() => handleChange('')}
        onChange={({ target: { value } }) => {
          handleChange(value as string);
        }}
      >
        {!isLoading && personTypes && personTypes.length === 0 && (
          <MenuItem disabled>No data available</MenuItem>
        )}
        {!isLoading &&
          personTypes &&
          personTypes.map((d, index) => {
            return (
              <MenuItem key={d.value} value={d.value}>
                {d.shorthand}
              </MenuItem>
            );
          })}
      </SMBSelect>
      {message && <FormHelperText error>{message}</FormHelperText>}
    </FormControl>
  );
};
